import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { translateTextFunc } from "../../../store/custom-actions/language/TranslateTextSlicer";
import SubmitButton from "../../components/ui/SubmitButton";

export default function TranslateCard({ stringKey, initialValue, langId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      string_key: stringKey,
      translate_word: initialValue,
    },
  });

  const { loading } = useSelector((state) => state.translateTextSlicer);

  const onSubmit = async (data) => {
    await dispatch(translateTextFunc({ id: langId, data }));
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-white rounded shadow p-4 border"
    >
      <h6 className="small fw-semibold text-secondary mb-2">
        {t("Original Text")}: <span className="text-primary">{stringKey}</span>
      </h6>

      <div className="mb-3">
        <textarea
          {...register("translate_word", {
            required: t("Translation is required"),
          })}
          className="form-control"
          style={{ minHeight: "80px" }}
        />
        {errors.translate_word && (
          <p className="text-danger small mt-1">
            {errors.translate_word.message}
          </p>
        )}
      </div>

      <SubmitButton
        isLoading={loading}
        form={undefined}
        label={t("Submit Translation")}
        loadingLabel={t("Submitting...")}
      />
    </form>
  );
}
